import { func_print } from "./func_print";

export const formatarNumero_ao_digitar = (valor: any): string => {
    let valor_sem_letras = valor.replace(/[^\d,]/g, "");

    const partes = valor_sem_letras.split(",");
    // partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return partes.join(",");
};

export const formatarNumero_recebido_com_casa_decimais = (valor: number) => {
    if (valor === null || valor === undefined ||isNaN(valor)){
        return "0,00";
    }
    return valor.toLocaleString("pt-PT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
export const formatarNumero_recebido_com_casa_decimais_aux = (valor: number, casas_decimais: number) => {
    if (valor === null || valor === undefined ||isNaN(valor)){
        return "0,00";
    }
    return valor.toLocaleString("pt-PT", { minimumFractionDigits: casas_decimais, maximumFractionDigits: casas_decimais });
}

export const formatarNumero_recebido_sem_casa_decimais = (valor: any): any => {
    if (valor === null || valor === undefined) return 0;
    const numero = parseInt(valor, 10);
    if (isNaN(numero)) return 0;
    return numero.toLocaleString("pt-PT");
}

// export const desformatarNumero = (valor: any): number => {
//     if (!valor) return 0; 

//     const valorSemFormatacao = valor.replace(/\s/g, "").replace(",", ".");

//     const numero = parseFloat(valorSemFormatacao);
//     return isNaN(numero) ? 0 : numero; 
// }

export const desformatarNumero = (valor: any): number => {
    if (valor === null || valor === undefined) return 0;

    if (typeof valor === "number") return valor;
    if (typeof valor === "string") {
        const valorSemFormatacao = valor.replace(/\s/g, "").replace(",", ".");
        const numero = parseFloat(valorSemFormatacao);
        return isNaN(numero) ? 0 : numero;
    }
    return 0;
};


export const desformatarNumero_return_null = (valor: any): number | null => {
    if (!valor) return null;

    const valorSemFormatacao = valor.replace(/\s/g, "").replace(",", ".");

    const numero = parseFloat(valorSemFormatacao);
    return isNaN(numero) ? null : numero;
}

export const desformatarNumero_5D_calculos = (valor: any): number => {
    if (typeof valor !== "string") {
        return parseFloat(valor) || 0;
    }
    const numero = valor.replace(/\./g, "").replace(",", ".");
    return parseFloat(numero) || 0;
}


